import * as React from "react";
import i18n from "../../i18n/i18n";
import * as PropTypes from "prop-types";
import * as classNames from "classnames";
import IErrorVm from "../../models/home/Error/IErrorVm";

interface ISelectProps {
  readonly?: boolean;
  value: any;
  label: string;
  spanType?: "span1" | "span2" | "span3" | "span4" | "span5" | "span6" | "span7" | "span8" | "span9" | "span10" | "span11" | "span12";
  options: IOptionsItem[];
  errorProperty?: string;
  uiTestAttribute?: string;
  useMinWidth?: boolean;
  useMaxWidth?: boolean;
  onChange: (key: any) => void;
}

export interface IOptionsItem {
  key: any;
  value: string;
}

export default class Select extends React.Component<ISelectProps> {
  public context: { errors: IErrorVm[] };
  public static contextTypes: React.ValidationMap<any> = {
    errors: PropTypes.array,
  };

  public static defaultProps: Partial<ISelectProps> = {
    readonly: false,
  };

  public render() {
    const { readonly, value, label, onChange, options, spanType, errorProperty, useMinWidth, uiTestAttribute, useMaxWidth = false } = this.props;

    const errors = (this.context.errors || []).filter((x: IErrorVm) => {
      return !readonly && x.property === errorProperty;
    });

    const labelClasses = classNames({
      required: errorProperty && !readonly,
    });

    const divClasses = classNames({
      "datafield datafield-textfield": true,
      span1: spanType === "span1",
      span2: spanType === "span2",
      span3: spanType === "span3",
      span4: spanType === "span4",
      span5: spanType === "span5",
      span6: spanType === "span6",
      span7: spanType === "span7",
      span8: spanType === "span8",
      span9: spanType === "span9",
      span10: spanType === "span10",
      span11: spanType === "span11",
      span12: spanType === "span12",
    });

    const minWidthStyle: React.CSSProperties = { minWidth: "150px" };

    return (
      <div className={divClasses} style={useMinWidth ? minWidthStyle : {}}>
        <label htmlFor={label} className={labelClasses}>
          {i18n.t(label)}
        </label>
        {
          <div id={label}>
            <select
              disabled={readonly}
              value={value}
              onChange={(e) => {
                onChange(e.target.value);
              }}
              className={"span12"}
              data-ui-test={uiTestAttribute}
              style={useMaxWidth ? { width: "100", maxWidth: "70%" } : {}}
            >
              {options &&
                options.map((o) => {
                  return (
                    <option key={o.key} value={o.key}>
                      {o.value}
                    </option>
                  );
                })}
            </select>
          </div>
        }
        {errors.map((err, i) => {
          return (
            <p key={i} className="alert alert-warning">
              {err.message}
            </p>
          );
        })}
      </div>
    );
  }
}
